<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="50%" :before-close="closeDialog">
    <div style="border: 1px solid #e8e8e8;box-sizing: border-box;padding: 20px;">
      <div>一、接入方式：</div>
      <div>1、OAUTH2框架接入：</div>
      <div>1）引入maven依赖：</div>
      <div class="bc">
        <div>{{ text }}</div>
        <div class="m10">{{ text1 }}</div>
        <div class="m10">{{ text2 }}</div>
        <div>{{ text3 }}</div>
      </div>
      <div>2）声明配置文件：</div>
      <div class="bc">
        <div>security:</div>
        <div class="m10">oauth2:</div>
        <div class="m20">client:</div>
        <div class="m30">registration:</div>
        <div class="m40">客户端名称:</div>
        <div class="m50">provider: spring</div>
        <div class="m50">client-id: 注册的客户端id</div>
        <div class="m50">client-secret: 注册的客户端secret</div>
        <div class="m50">authorization-grant-type: authorization_code</div>
        <div class="m50">redirect-uri: "域名/login/oauth2/code/{registrationId}"</div>
        <div class="m50">scope: openid</div>
        <div class="m50">client-name: 客户端名称</div>
        <div class="m30">provider:</div>
        <div class="m40">spring:</div>
        <div class="m50">authorization-uri: https://platform.iiasx.org.cn/oauth2/authorize</div>
        <div class="m50">token-uri: https://platform.iiasx.org.cn/oauth2/token</div>
        <div class="m50">jwk-set-uri: https://platform.iiasx.org.cn/oauth2/jwks</div>
      </div>
      <div>3）应用回调地址（固定格式）：域名/login/oauth2/code/客户端名称</div>
      <div>4）设置security：</div>
      <div class="bc">
        <div>http.oauth2Login.loginPage("/oauth2/authorization/客户端名称"))</div>
        <div>.oauth2Client(withDefaults());</div>
      </div>
      <div>5）登录入口地址（管理端生成）：<div class="bc">域名/oauth2/authorization/客户端名称</div>
      </div>
      <div>6）通过登录入口地址跳转，并输入正确的用户名和密码后，用户可自动登录。后续自行处理待接入系统的前端用户验证机制。</div>
      <div>2、调用接口接入：</div>
      <div>1）声明配置文件：</div>
      <div class="bc">
        <div>clientId: 注册的客户端id</div>
        <div>clientSecret: 注册的客户端secret</div>
        <div>clientCallBack: 回调地址</div>
        <div>clientToken: https://platform.iiasx.org.cn/oauth2/token</div>
        <div>clientUserInfo: https://platform.iiasx.org.cn/userinfo</div>
      </div>
      <div>2）应用回调地址clientCallBack，用户可自定义。在应用回调地址中完成单独登录后的信息解析，并生成用户TOKEN。</div>
      <div>示例代码如下：</div>
      <div class="bc">
        <div class="m10">@RequestMapping("/callbackCode")</div>
        <div class="m10">public Object toLogin(HttpServletRequest request,HttpServletResponse resp)throws
          OAuthProblemException {</div>
        <div class="m20">String code = request.getParameter("code");</div>
        <div class="m20">OAuthClient oAuthClient =new OAuthClient(new URLConnectionClient());</div>
        <div class="m20">try {</div>
        <div class="m30">String secret = clientId+":"+clientSecret;</div>
        <div class="m30">byte[] inputBytes = secret.getBytes(StandardCharsets.UTF_8);</div>
        <div class="m30">byte[] encodedBytes = Base64.getEncoder().encode(inputBytes);</div>
        <div class="m30">String encodedString = new String(encodedBytes, StandardCharsets.UTF_8);</div>

        <div class="m30">OAuthClientRequest accessTokenRequest = OAuthClientRequest</div>
        <div class="m30">.tokenLocation(clientToken)</div>
        <div class="m30">.setGrantType(GrantType.AUTHORIZATION_CODE)</div>
        <div class="m30">.setClientId(clientId)</div>
        <div class="m30">.setClientSecret(clientSecret)</div>
        <div class="m30">.setCode(code)</div>
        <div class="m30">.setScope(OidcScopes.OPENID)</div>
        <div class="m30">.setRedirectURI(clientCallBack)</div>
        <div class="m30">.buildQueryMessage();</div>

        <div class="m30">accessTokenRequest.addHeader("Authorization","Basic "+encodedString);</div>
        <div class="m30">//去服务端请求access token，并返回响应</div>
        <div class="m30">OAuthAccessTokenResponse oAuthResponse = oAuthClient.accessToken(accessTokenRequest,
          OAuth.HttpMethod.POST);</div>
        <div class="m30">//获取服务端返回过来的access token</div>
        <div class="m30">String accessToken = oAuthResponse.getAccessToken();</div>
        <div class="m30">//查看access token是否过期</div>
        <div class="m30">Long expiresIn =oAuthResponse.getExpiresIn();</div>
        <div class="m30">resp.sendRedirect("/oauth/getUserInfo?accessToken="+accessToken);</div>
        <div class="m20">} catch (OAuthSystemException | IOException e) {</div>
        <div class="m30">e.printStackTrace();</div>
        <div class="m20">}</div>
        <div class="m30">return null;</div>
        <div class="m10">}</div>
      </div>
      <div>3）步骤2中/oauth/getUserInfo为用户解析地址，用户可自行定义。</div>
      <div>该地址实现用户解析，获取登录的用户名，示例如下：</div>
      <div class="bc">
        <div>@RequestMapping("/getUserInfo")</div>
        <div>@ResponseBody</div>
        <div>public string accessToken(String accessToken,HttpServletRequest request, HttpServletResponse resp) throws
        </div>
        <div>IOException {</div>
        <div class="m10">OAuthClient oAuthClient =new OAuthClient(new URLConnectionClient());</div>
        <div class="m10">try {</div>
        <div class="m20">OAuthClientRequest userInfoRequest = new
          OAuthBearerClientRequest(clientUserInfo).buildQueryMessage();</div>
        <div class="m20">userInfoRequest.addHeader("Authorization", "Bearer " + accessToken);</div>
        <div class="m20">OAuthResourceResponse resourceResponse = oAuthClient.resource(userInfoRequest,
          OAuth.HttpMethod.POST,</div>
        <div class="m20">OAuthResourceResponse.class);</div>
        <div class="m20">String body = resourceResponse.getBody();</div>
        <div class="m20">Gson gson = new Gson(); // 将字符串转为JSON对象</div>
        <div class="m20">JsonObject jsonObject = gson.fromJson(body, JsonObject.class);</div>
        <div class="m20">String name = jsonObject.get("sub").getAsString();</div>
        <div class="m20">return name;</div>
        <div class="m10">} catch (Exception e) {</div>
        <div class="m20">return "";</div>
        <div class="m10">}</div>
        <div>}</div>
      </div>
      <div>4）登录入口地址（管理端生成）：<div class="bc">
          域名/oauth2/authorize?scope=openid&client_id=clientId&response_type=code&redirect_uri=clientCallBack</div>
      </div>
      <div>5）通过登录入口地址跳转，并输入正确的用户名和密码后，可获取到登录的用户，后续自行处理待接入系统的前端用户验证机制。</div>
      <div>二、接入流程</div>
      <div>1）进入控制台 > 我的应用 > 发布应用</div>
      <div>2）填写应用详情：</div>
      <div><img src="../../../assets/images/t1.png" alt="" srcset=""></div>
      <div>用户同步地址，用于绑定公共服务平台与接入平台的用户，接口详情如下：</div>
      <div><img src="../../../assets/images/t2.png" alt="" srcset=""></div>
      <div>3）管理端审核通过后，可获取clientId和clientSecret</div>
      <div><img src="../../../assets/images/t3.png" alt="" srcset=""></div>
      <div>4）获取到相关信息后，按照接入方式进行系统接入。</div>
      <div>5）接入后，可通过登录入口地址进行测试。账号密码为公共服务平台对应的用户名和密码。</div>
      <div>6）点击同步用户，输入要接入平台的用户名和密码，完成账号绑定。</div>
      <div>此步骤考虑到待接入的系统可能通过其他用户进行登录，用户绑定逻辑和自动登录逻辑自行处理。</div>
      <div><img src="../../../assets/images/t4.png" alt="" srcset=""></div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      title: '接入教程',
      dialogVisible: false,
      text: '<dependency>',
      text1: '<groupId>org.springframework.boot</groupId>',
      text2: '<artifactId>spring-boot-starter-oauth2-client</artifactId>',
      text3: '</dependency>'
    }
  },
  methods: {
    closeDialog() {
      this.dialogVisible = false
    },
    openDialog() {
      this.dialogVisible = true
    }
  }
}
</script>
<style scoped>
/deep/ .el-dialog__body {
  height: 600px !important;
  overflow: scroll
}

.m10 {
  padding-left: 10px;
  font-size: 20px;
}

.m20 {
  padding-left: 20px;
  font-size: 18px;
}

.m30 {
  padding-left: 30px;
  font-size: 16px;
}

.m40 {
  padding-left: 40px;
  font-size: 14px;
}

.m50 {
  padding-left: 50px;
  font-size: 14px;
}

.bc {
  background: #e6e6e6
}

div {
  font-size: 20px;
  line-height: 30px
}

img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/console/components/CourseDialog.vue